// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.
import "../../style/sassStyle";

import { Button } from "components/ui/Buttons";
import React from "react";
import { signout } from "store/auth";

interface SignOutButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  onClick?: (event: React.KeyboardEvent | React.MouseEvent) => void;
}

export default (props: SignOutButtonProps) => {
  return (
    <Button
      onClick={async event => {
        props.onClick && props.onClick(event);

        event.preventDefault();

        await signout();
      }}
      className={props.className}
    >
      Logout
    </Button>
  );
};
